let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hTXkx")).then(() => parcelRequire('dtCyq'));